import {cssTheme} from '@logistics-frontend/blocks/theme'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const main = css`
  background-color: ${cssTheme.default.day.backgroundInvert};
  margin-block-start: ${spacing(7.75)};
  position: relative;
`

export const headerSection = css`
  border-start-end-radius: 0;
  border-start-start-radius: 0;
  margin-block-end: ${spacing(0.25)};
`

export const bodySection = css`
  margin-block-end: ${spacing(0.25)};
  padding: ${spacing(1, 2)};
`

export const bottomSectionWrapper = css`
  display: inline;
  position: relative;
  background-color: ${cssTheme.colors.absolute.white};
`
